
<template>
<svg data-v-62c93367="" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline data-v-62c93367="" points="15 18 9 12 15 6"></polyline></svg>
</template>
    
  <script>
  export default {
    components: {
    },
    props: {
    },
    data() {
      return {
      }
    },
  }
  </script>
  
  <style lang="scss" scoped>
  svg {
    height: 18px;
  }  
  </style>
    
    